import React from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Active",
        value: "1"
    },
    {
        text: "Inactive",
        value: "2"
    }
];

const eliteOptions = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Active Elite",
        value: "1"
    },
    {
        text: "Expired Elite",
        value: "3"
    },
    {
        text: "Non Elite",
        value: "2"
    }
];

const searchFields = (props) => {
    return (
        <CardSimple className="mb-2">
            <div className="row m-0">
                {/*Search Inputs*/}
                <div className="row m-0">
                    <div className="col-sm-3">
                        <TextInput
                            type="number"
                            name={`${props.pageName}MemberNumberFilter`}
                            className="search-field"
                            label={LOOKUP.patient.filters.memberNumber.label}
                            floatingLabelText={LOOKUP.patient.filters.memberNumber.label}
                            hintText={LOOKUP.patient.filters.memberNumber.hintText}
                            maxLength={20}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}FisrtNameFilter`}
                            className="search-field"
                            label={LOOKUP.patient.filters.firstName.label}
                            floatingLabelText={LOOKUP.patient.filters.firstName.label}
                            hintText={LOOKUP.patient.filters.firstName.hintText}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}LastNameFilter`}
                            className="search-field"
                            label={LOOKUP.patient.filters.lastName.label}
                            floatingLabelText={LOOKUP.patient.filters.lastName.label}
                            hintText={LOOKUP.patient.filters.lastName.hintText}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}CardNumberFilter`}
                            className="search-field"
                            label={LOOKUP.patient.filters.cardNumber.label}
                            floatingLabelText={LOOKUP.patient.filters.cardNumber.label}
                            hintText={LOOKUP.patient.filters.cardNumber.hintText}
                            onPressKey={props.search} />
                    </div>
                    <div className="col-sm-3">
                        <SelectInput
                            name={`${props.pageName}Status`}
                            className="search-field"
                            label="Status"
                            floatingLabelText="Status"
                            defaultValue="None"
                            options={statusOptions} />
                    </div>
                    {props.isMedical && <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}CareGiver`}
                            className="search-field"
                            label={LOOKUP.patient.filters.careGiver.label}
                            floatingLabelText={LOOKUP.patient.filters.careGiver.label}
                            hintText={LOOKUP.patient.filters.careGiver.hintText}
                            onPressKey={props.search}
                        />
                    </div>}
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}PhoneNumber`}
                            className="search-field"
                            label={LOOKUP.patient.filters.phoneNumber.label}
                            floatingLabelText={LOOKUP.patient.filters.phoneNumber.label}
                            hintText={LOOKUP.patient.filters.phoneNumber.hintText}
                            onPressKey={props.search}
                        />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            name={`${props.pageName}Email`}
                            className="search-field"
                            label={LOOKUP.patient.filters.email.label}
                            floatingLabelText={LOOKUP.patient.filters.email.label}
                            hintText={LOOKUP.patient.filters.email.hintText}
                            onPressKey={props.search}
                        />
                    </div>
                    {
                        props.isHighTide &&
                        <div className="col-sm-3">
                            <SelectInput
                                name={`${props.pageName}EliteFilter`}
                                className="search-field"
                                label="Elite Filter"
                                floatingLabelText="Elite Filter"
                                defaultValue="0"
                                options={eliteOptions}
                            />
                        </div>
                    }
                </div>
                <div className="row m-0 mt-2 search-buttons justify-content-end">
                    <div className="col-auto d-flex align-items-center">
                        <Button
                            type="IconSearchButton"
                            id="buttonSearchMember"
                            label={LOOKUP.patient.filters.filterButton}
                            onTouchTap={props.search}
                            className="btnNewBrandPOS" />
                        <Button
                            className="btnCleanSearch ml-8px"
                            type="IconClearButton"
                            label={LOOKUP.patient.filters.cleanFilterButton}
                            onTouchTap={props.cleanSearch} />
                    </div>
                </div>
            </div>
        </CardSimple>
    );
};


export default searchFields;
